module.exports = __webpack_public_path__ + "media/images/sections/professional_development-588651fe984a5b92e1fbdabcfd182289.png";